export const PLACEHOLDER_IMAGE = '/assets/placeholder/placeholder.webp';